import { LeaderProfilePropsList } from "../components/profile";
import alana from "../assets/alana.png";
import anjali from "../assets/anjali.png";
import jamie from "../assets/jamie.png";
import dhruv from "../assets/dhruv.png";
import jase from "../assets/jase.png";
import prince from "../assets/prince.png";
import bowen from "../assets/bowen.png";
import sarah from "../assets/sarah.jpg";


const leadership: LeaderProfilePropsList = [
  {
    name: "Jase Villaverde",
    position: "Co-Founder",
    schoolgrade: "MHS '27",
    image: jase,
  },
  {
    name: "Dhruv Patel",
    position: "Co-Founder",
    schoolgrade: "MHS '27",
    image: dhruv,
  },
  {
    name: "Anjali Shah",
    position: "Events Chair",
    schoolgrade: "MHS '27",
    image: anjali,
  },
  {
    name: "Sarah Bu",
    position: "Fundraising Chair",
    schoolgrade: "MHS '27",
    image: sarah,
  },
  {
    name: "Jamie Firsichbaum",
    position: "Outreach Chair",
    schoolgrade: "MHS '27",
    image: jamie,
  },
  {
    name: "Prince Patel",
    position: "Volunteering Chair",
    schoolgrade: "MHS '27",
    image: prince,
  },
  {
    name: "Bowen Zhang",
    position: "Web Developer",
    schoolgrade: "MHS '27",
    image: bowen,
  },
];

export default leadership;
